module.exports = __webpack_public_path__ + "img/p91.efbbcbe1.png";